import deDeSnippets from '../module/extension/sw-first-run-wizard/snippets/de-DE.json';
import enGBSnippets from '../module/extension/sw-first-run-wizard/snippets/en-GB.json';

Shopware.Locale.extend('de-DE', deDeSnippets);
Shopware.Locale.extend('en-GB', enGBSnippets);
